import { useCallback } from 'react';

interface UseFileDownloadOptions {
  mimeType?: string;
}

export const useFileDownload = (options?: UseFileDownloadOptions) => {
  const defaultMimeType = 'application/zip';

  const downloadFile = useCallback(
    (data: BlobPart, filename: string) => {
      const mimeType = options?.mimeType || defaultMimeType;
      const blob = new Blob([data], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    [options?.mimeType, defaultMimeType]
  );

  return { downloadFile };
};
